import { formatDobInput } from '../../utils/contactFields'

export default function ContactDobField({ label, placeholder, value, onChange }) {
  return (
    <div className="flex flex-col gap-1 mb-3">
      <label className="text-xs text-gray-500">{label}</label>
      <input
        type="text"
        inputMode="numeric"
        autoComplete="bday"
        className="border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder={placeholder}
        value={value ?? ''}
        onChange={e => onChange(formatDobInput(e.target.value))}
        maxLength={10}
      />
    </div>
  )
}
